import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { interval, Subscription } from 'rxjs';
import { StopWatchDTO } from '../../common/domain-model-dtos';

@Component({
  selector: 'app-stopwatch',
  templateUrl: './stopwatch.component.html',
  styleUrls: ['./stopwatch.component.css'],
  standalone: false,
})
export class StopwatchComponent implements OnInit, OnDestroy {
  @Input() data: StopWatchDTO;

  @Input() presentStopwatchSeconds: boolean;

  private subscription: Subscription;

  milliSecondsInASecond = 1000;

  hoursInADay = 24;

  minutesInAnHour = 60;

  secondsInAMinute = 60;

  public timeDifference;

  public minutesFromDday;

  public secondsFromDday;

  public hoursFromDday;

  dDay: Date;

  constructor(private changeDetector: ChangeDetectorRef) {}

  private getTimeDifference() {
    if (this.data.startedInEpoch) {
      this.dDay = new Date(this.data.startedInEpoch);
      const formattedDate = moment(this.dDay).utc();
      this.timeDifference = moment().utc().diff(formattedDate);
    } else {
      this.timeDifference = 0;
    }
    this.allocateTimeUnits(this.timeDifference + this.data.initialValueInMs);
  }

  private allocateTimeUnits(timeDifference) {
    this.secondsFromDday = Math.floor((timeDifference / this.milliSecondsInASecond) % this.secondsInAMinute);
    this.minutesFromDday = Math.floor(
      (timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour)) % this.secondsInAMinute
    );
    this.hoursFromDday = Math.floor(
      timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour * this.secondsInAMinute)
    );
    this.changeDetector.detectChanges();
  }

  ngOnInit() {
    this.getTimeDifference();
    this.subscription = interval(1000 * (this.presentStopwatchSeconds ? 1 : 60)).subscribe((x) => {
      this.getTimeDifference();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
